import { morphism } from 'morphism'

import flightSchema from './flight'

import FlightModel from '../models/Flight'

const seatTradeDetails = ({ details = {} }) => {
  const { arrival, arrivalUtc, departure, departureUtc } = details
  const renamedTimesProperties = {
    sta: arrival,
    staUtc: arrivalUtc,
    std: departure,
    stdUtc: departureUtc,
  }

  const flightDetails = {
    ...details,
    ...renamedTimesProperties,
  }

  return morphism(flightSchema, flightDetails, FlightModel)
}

export default {
  availableSeatCount: 'availableSeatCount',
  details: seatTradeDetails,
  flightId: 'flightId',
}
